<template>
    <fieldset :class="{ outlined: outlined }">
        <legend v-show="label.length" class="px-1 ml-2 mb-n2">
            {{ label }}
        </legend>
        <v-chip-group column class="px-2">
            <span v-if="!value.length">
                {{ noDataText }}
            </span>
            <v-chip
                v-for="(item, index) in displayItems"
                :key="`tag-${index}`"
                v-bind="itemProps"
            >
                {{ item.name || item }}
            </v-chip>
            <v-chip v-if="showMoreItem" v-bind="itemProps">
                <v-tooltip top>
                    <template v-slot:activator="{ on }">
                        <span v-on="on">
                            {{ showMoreItem }}
                        </span>
                    </template>
                    <div class="tags-tooltip">
                        <div
                            v-for="(item, index) in value"
                            :key="`tag-tooltip-${index}`"
                        >
                            {{ item.name || item }}
                        </div>
                    </div>
                </v-tooltip>
            </v-chip>
        </v-chip-group>
    </fieldset>
</template>

<script>
import { VChipGroup, VTooltip } from 'vuetify/lib';

export default {
    name: 'TagsChipGroup',
    components: {
        'v-chip-group': VChipGroup,
        'v-tooltip': VTooltip
    },
    props: {
        value: {
            type: Array,
            required: false,
            default: () => []
        },
        itemProps: {
            type: Object,
            required: false,
            default: () => ({ small: true })
        },
        maxDisplayCount: {
            type: Number,
            required: false,
            default: -1
        },
        outlined: {
            type: Boolean,
            required: false,
            default: false
        },
        noDataText: {
            type: String,
            required: false,
            default: '(No data found)'
        },
        label: {
            type: String,
            required: false,
            default: ''
        }
    },
    computed: {
        displayItems() {
            if (
                this.value &&
                this.value.length &&
                this.maxDisplayCount > 0 &&
                this.maxDisplayCount < this.value.length
            ) {
                return this.value.slice(0, this.maxDisplayCount);
            }
            return this.value;
        },
        showMoreItem() {
            if (
                this.value &&
                this.value.length &&
                this.maxDisplayCount > 0 &&
                this.maxDisplayCount < this.value.length
            ) {
                const more = this.value.length - this.maxDisplayCount;
                return `(+${more} other${more > 1 ? 's' : ''})`;
            }
            return null;
        }
    }
};
</script>

<style lang="scss" scoped>
fieldset {
    border-width: 0;
    border-style: hidden;
    &.outlined {
        border-width: 1px;
        border-radius: 4px;
        border-style: solid;
    }
}
</style>
